import { AxiosResponse } from 'axios';
import { privateFetcher } from 'services';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';

const cancelReturnTicket = async (
  orgId: number,
  returnUuid: string,
  params: {
    // eslint-disable-next-line camelcase
    return_status: string;
  },
): Promise<AxiosResponse> => {
  const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/return-tickets/${orgId}/cancel/${returnUuid}/`;

  try {
    return await privateFetcher.put(url, params);
  } catch (error) {
    throw new APIError(error.message);
  }
};
export { cancelReturnTicket };
